import React from "react";
import styles from "./BetaTag.module.css";

export const BetaTag = () => <sup className={styles.beta}>Beta</sup>;
